/** Shared parsers for JSON stored in site_settings. */

export const DEFAULT_HEADER_LOGO = '/assets/InvicibleLogo.png';
export const DEFAULT_FOOTER_LOGO = '/assets/logo.svg';

export const DEFAULT_FOOTER_QUICK_LINKS = [
  { label: 'About Us', path: '/about' },
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'Careers', path: '/careers' },
  { label: 'Blog', path: '/blogs' },
  { label: 'Contact', path: '/contact' }
];

export const DEFAULT_INITIATIVES_CARDS = [
  {
    title: 'Environmental Conservation',
    description:
      "We're committed to preserving the natural beauty of the places we explore through responsible tourism and conservation efforts."
  },
  {
    title: 'Community Support',
    description:
      'Supporting local communities in adventure destinations through partnerships and sustainable tourism practices.'
  },
  {
    title: 'Education & Awareness',
    description:
      'Promoting outdoor education and environmental awareness through workshops, seminars, and educational programs.'
  }
];

export const DEFAULT_TERMS_HTML = `<p>By booking with Invincible, you agree to follow trip guidelines, safety instructions, and cancellation/refund policies shared at booking time.</p>
<p>Final participation is subject to weather, operational conditions, and organizer safety decisions. Misconduct or non-compliance may lead to removal from the trip without refund.</p>`;

export const DEFAULT_PRIVACY_HTML = `<p>We collect only the details needed for booking, operations, and support. Your personal information is used to manage your participation and improve service quality.</p>
<p>We do not sell your personal data. Information may be shared only with trusted partners necessary to deliver booked services or where legally required.</p>`;

/**
 * @param {Record<string, string>} settings
 * @param {'header' | 'footer'} variant
 */
export function resolveBrandLogoUrl(settings, variant) {
  const key = variant === 'header' ? 'site_header_logo_url' : 'site_footer_logo_url';
  const fallback = variant === 'header' ? DEFAULT_HEADER_LOGO : DEFAULT_FOOTER_LOGO;
  const shared = String(settings?.site_public_logo_url || '').trim();
  const specific = String(settings?.[key] || '').trim();
  return specific || shared || fallback;
}

/**
 * @param {string} raw
 * @returns {{ label: string, path: string }[]}
 */
export function parseFooterQuickLinks(raw) {
  if (!raw || typeof raw !== 'string') return DEFAULT_FOOTER_QUICK_LINKS;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || !parsed.length) return DEFAULT_FOOTER_QUICK_LINKS;
    const links = parsed
      .map((item) => ({
        label: String(item?.label || '').trim(),
        path: String(item?.path || '').trim()
      }))
      .filter((item) => item.label && item.path);
    return links.length ? links : DEFAULT_FOOTER_QUICK_LINKS;
  } catch {
    return DEFAULT_FOOTER_QUICK_LINKS;
  }
}

/**
 * @param {string} raw
 * @returns {{ title: string, description: string }[]}
 */
export function parseInitiativesCards(raw) {
  if (!raw || typeof raw !== 'string') return DEFAULT_INITIATIVES_CARDS;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || !parsed.length) return DEFAULT_INITIATIVES_CARDS;
    const cards = parsed
      .map((item) => ({
        title: String(item?.title || '').trim(),
        description: String(item?.description || '').trim()
      }))
      .filter((item) => item.title);
    return cards.length ? cards : DEFAULT_INITIATIVES_CARDS;
  } catch {
    return DEFAULT_INITIATIVES_CARDS;
  }
}
